const backfillContactsTypeFix = async (db: IDBDatabase) => {
  const tx = db.transaction(["pendingContacts"], "readwrite");

  // backfill contacts type fix for pending contacts
  const pendingContactsObjectStore = tx.objectStore("pendingContacts");
  const pendingContactRequest = pendingContactsObjectStore.openCursor();
  await new Promise((resolve, reject) => {
    pendingContactRequest.onsuccess = (event) => {
      const cursor = (event.target as any).result as IDBCursorWithValue;

      if (cursor) {
        const contact = cursor.value;

        cursor.update({
          ...contact,
          isBusiness:
            contact?.contactTaxNumber !== "" &&
            contact?.contactTaxNumber != null
              ? true
              : false,
        } satisfies PendingContactsSchema);
        cursor.continue();
      } else {
        resolve(null);
      }
    };

    pendingContactRequest.onerror = () => {
      reject(new Error("Failed to iterate over pending contacts"));
    };
  });
};

export default backfillContactsTypeFix;
